import React, { createContext, useState, useContext } from "react";

const AlarmContext = createContext();

export const AlarmProvider = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const contextValue = React.useMemo(
    () => ({ isPlaying, setIsPlaying }),
    [isPlaying]
  );

  return (
    <AlarmContext.Provider value={contextValue}>
      {children}
    </AlarmContext.Provider>
  );
};

export const useAlarm = () => useContext(AlarmContext);
